const productData1 = [
  {
    title: "Maison Margiela",
    description: "oversize paint-splatter denim jacket",
    images: [
      "https://cdn-images.farfetch-contents.com/19/26/97/09/19269709_42348337_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/26/97/09/19269709_42348343_480.jpg",
    ],
    price: 2611,
  },
  {
    title: "Balmain",
    description: "Unicorn low-top sneekers",
    images: [
      "https://cdn-images.farfetch-contents.com/19/07/33/18/19073318_41935484_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/07/33/18/19073318_41935493_480.jpg",
    ],
    price: 2506,
  },
  {
    title: "Moncler",
    description: "Herniaire houndstooth padded gilet",
    images: [
      "https://cdn-images.farfetch-contents.com/19/27/49/98/19274998_42305118_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/27/49/98/19274998_42305119_480.jpg",
    ],
    price: 3140,
  },
  {
    title: "Valentino Garavani",
    description: "VLTN leather cardholder",
    images: [
      "https://cdn-images.farfetch-contents.com/19/24/83/44/19248344_42273195_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/24/83/44/19248344_42271308_480.jpg",
    ],
    price: 354,
  },
];

const productData2 = [
  {
    title: "visvim",
    description: "logo-patch wool beanie hit",
    images: [
      "https://cdn-images.farfetch-contents.com/18/34/30/11/18343011_42222448_600.jpg",
      "https://cdn-images.farfetch-contents.com/18/34/30/11/18343011_42222449_480.jpg",
    ],
    price: 330,
  },
  {
    title: "Mastermind Japan",
    description: "skull-motif tote bag",
    images: [
      "https://cdn-images.farfetch-contents.com/19/18/58/17/19185817_42152229_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/18/58/17/19185817_42152228_480.jpg",
    ],
    price: 1483,
  },
  {
    title: "AMI Paris",
    description: "Ami de Coeur roll-neck jumper",
    images: [
      "https://cdn-images.farfetch-contents.com/17/99/37/26/17993726_38415070_600.jpg",
      "https://cdn-images.farfetch-contents.com/17/99/37/26/17993726_38414610_480.jpg",
    ],
    price: 570,
  },
  {
    title: "Dolce & Gabbana",
    description: "NS1 low-top sneakers",
    images: [
      "https://cdn-images.farfetch-contents.com/18/61/17/80/18611780_41705359_600.jpg",
      "https://cdn-images.farfetch-contents.com/18/61/17/80/18611780_41705353_480.jpg",
    ],
    price: 925,
  },
];

const womenProductList1 = [
  {
    title: "Gucci",
    description: "GG-jacquard knitted vest",
    images: [
      "https://cdn-images.farfetch-contents.com/19/10/05/61/19100561_42312996_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/10/05/61/19100561_42315391_480.jpg",
    ],
    price: 920,
  },
  {
    title: "Gucci",
    description: "GG logo-plaque shoulder bag",
    images: [
      "https://cdn-images.farfetch-contents.com/19/09/66/14/19096614_42303148_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/09/66/14/19096614_42303145_480.jpg",
    ],
    price: 2100,
  },
  {
    title: "Valentino Garavani",
    description: "Tan-Go 165mm platform pumps",
    images: [
      "https://cdn-images.farfetch-contents.com/18/74/40/63/18744063_42276872_600.jpg",
      "https://cdn-images.farfetch-contents.com/18/74/40/63/18744063_42277209_480.jpg",
    ],
    price: 2207,
  },
  {
    title: "Mugler",
    description: "x Wolford semi-sheer panelled minidress",
    images: [
      "https://cdn-images.farfetch-contents.com/19/27/74/50/19277450_42390050_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/27/74/50/19277450_42351131_480.jpg",
    ],
    price: 881,
  },
];

const womenProductList2 = [
  {
    title: "Prada",
    description: "small brushed tote bag",
    images: [
      "https://cdn-images.farfetch-contents.com/18/58/26/18/18582618_40851734_600.jpg",
      "https://cdn-images.farfetch-contents.com/18/58/26/18/18582618_40852464_480.jpg",
    ],
    price: 4490,
  },
  {
    title: "Manolo Blahnik",
    description: "",
    images: [
      "https://cdn-images.farfetch-contents.com/13/15/01/28/13150128_30475816_600.jpg",
      "https://cdn-images.farfetch-contents.com/13/15/01/28/13150128_30476901_480.jpg",
    ],
    price: 2328,
  },
  {
    title: "Anissa Kermiche",
    description: "Love Handles vase (33cm)",
    images: [
      "https://cdn-images.farfetch-contents.com/14/57/76/98/14577698_29297010_600.jpg",
      "https://cdn-images.farfetch-contents.com/14/57/76/98/14577698_29298043_480.jpg",
    ],
    price: 646,
  },
  {
    title: "Saint Laurent",
    description: "logo-plaque quilted AirPods case",
    images: [
      "https://cdn-images.farfetch-contents.com/17/60/96/70/17609670_37668600_600.jpg",
      "https://cdn-images.farfetch-contents.com/17/60/96/70/17609670_37667581_480.jpg",
    ],
    price: 645,
  },
];

const kidsProduct1 = [
  {
    title: "Moncler Enfant",
    description: "ribbed-knit pompom beanie",
    images: [
      "https://cdn-images.farfetch-contents.com/19/20/69/39/19206939_42132621_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/20/69/39/19206939_42132618_480.jpg",
    ],
    price: 269,
  },
  {
    title: "Kenzo Kids",
    description: "Sleep Well babygrow set",
    images: [
      "https://cdn-images.farfetch-contents.com/17/91/92/21/17919221_41558238_600.jpg",
      "https://cdn-images.farfetch-contents.com/17/91/92/21/17919221_41554981_480.jpg",
    ],
    price: 273,
  },
  {
    title: "Chloé Kids",
    description: "faux-shearling collared coat",
    images: [
      "https://cdn-images.farfetch-contents.com/17/91/15/32/17911532_42281091_600.jpg",
      "https://cdn-images.farfetch-contents.com/17/91/15/32/17911532_42277962_480.jpg",
    ],
    price: 520,
  },
  {
    title: "Balmain Kids",
    description: "logo-intarsia beanie hat",
    images: [
      "https://cdn-images.farfetch-contents.com/19/09/69/30/19096930_42156134_600.jpg",
      "https://cdn-images.farfetch-contents.com/19/09/69/30/19096930_42156130_480.jpg",
    ],
    price: 205,
  },
];

const kidsProduct2 = [
  {
    title: "",
    description: "",
    images: [],
    price: "",
  },
  {
    title: "",
    description: "",
    images: [],
    price: "",
  },
  {
    title: "",
    description: "",
    images: [],
    price: "",
  },
  {
    title: "",
    description: "",
    images: [],
    price: "",
  },
];

export {
  productData1,
  productData2,
  womenProductList1,
  womenProductList2,
  kidsProduct1,
};
